//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { server, imageUrl } from "@/services/constants";
import api from "@/services/api";
export default {
  name: "Header",
  data() {
    return {
      mLoc: "",
      mycompany: [],
      th_name: "",
      eng_name: "",
      department_name: "",
      image: "",
      image_profile: "",
      user_text_profile: "",
      fab: false, // Add this line to control the FAB
    };
  },
  async mounted() {
    await this.getMyCompany();
    await this.loadEmpdata();
  },
  computed: {
    version() {
      return process.env.VUE_APP_VERSION;
    },
    title() {
      return process.env.VUE_APP_TITLE;
    },
    getENV() {
      return process.env.NODE_ENV;
    },
  },
  methods: {
    async loadEmpdata() {
      const res_emp = await api.getAccountByidMenu(
        localStorage.getItem(server.USER_ID)
      );

      this.th_name = res_emp.data[0].name;
      this.eng_name = res_emp.data[0].eng_name;
      this.department_name = res_emp.data[0].department_name;
      this.image = res_emp.data[0].image;

      if (this.image != "" && this.image != null) {
        this.image_profile = imageUrl + "/" + this.image;
        localStorage.setItem(server.USER_IMAGE_URL, this.image_profile);
      } else {
        this.user_text_profile =
          this.eng_name.slice(0, 1) +
          this.eng_name.split(" ")[2].substring(0, 1);
        localStorage.setItem(server.USER_IMAGE_URL, null);
      }
    },
    async getMyCompany() {
      const result = await api.getCompanyByID(
        localStorage.getItem(server.COMPANYID)
      );
      this.mycompany = result.data;
    },
    onClickLogOff() {
      this.$store.state.navMenu = false;
      this.$store.dispatch("doLogout");
    },
    resetPassword() {
      // alert("Reset Password");
      this.$router.push("/my-profile");
    },

    openChat() {
      const dTimeData = {
        dtime_token: localStorage.getItem("dtime_token"),
        dtime_user_id: localStorage.getItem("dtime_user_id"),
        dtime_username: localStorage.getItem("dtime_username"),
        dtime_email: localStorage.getItem("dtime_email"),
        dtime_fullname: localStorage.getItem("dtime_fullname"),
        dtime_role: localStorage.getItem("dtime_role"),
        dtime_company_id: localStorage.getItem("dtime_company_id"),
        dtime_department_id: localStorage.getItem("dtime_department_id"),
        dtime_position_id: localStorage.getItem("dtime_position_id"),
        dtime_user_image_url: localStorage.getItem("dtime_user_image_url"),
        dtime_login_url: window.location.origin, // เพื่อให้กลับมาหา D-Time ได้
      };

      // สร้าง URL parameters
      const params = new URLSearchParams();
      Object.entries(dTimeData).forEach(([key, value]) => {
        if (value) {
          params.set(key, value); // ไม่ต้อง encodeURIComponent เพราะ URLSearchParams จัดการให้แล้ว
        }
      });

      // เปิด Chat ใน tab ใหม่หรือ popup
      const chatUrl = `https://chat-dev.dcm.co.th?${params.toString()}`;
      // const chatUrl = `http://localhost:3000?${params.toString()}`;
      window.open(chatUrl, "chat", "width=1200,height=800");
    },

    openChat_V2() {
      const dTimeData = {
        dtime_token: localStorage.getItem("dtime_token"),
        dtime_user_id: localStorage.getItem("dtime_user_id"),
        dtime_username: localStorage.getItem("dtime_username"),
        dtime_email: localStorage.getItem("dtime_email"),
        dtime_fullname: localStorage.getItem("dtime_fullname"),
        dtime_role: localStorage.getItem("dtime_role"),
        dtime_company_id: localStorage.getItem("dtime_company_id"),
        dtime_department_id: localStorage.getItem("dtime_department_id"),
        dtime_position_id: localStorage.getItem("dtime_position_id"),
        dtime_user_image_url: localStorage.getItem("dtime_user_image_url"),
        dtime_login_url: window.location.origin, // เพื่อให้กลับมาหา D-Time ได้
      };

      // สร้าง URL parameters
      const params = new URLSearchParams();
      Object.entries(dTimeData).forEach(([key, value]) => {
        if (value) {
          params.set(key, encodeURIComponent(value));
        }
      });

      // เปิด Chat ใน tab ใหม่หรือ popup
      // const chatUrl = `https://chat-dev.dcm.co.th?${params.toString()}`; // Fixed the backticks
      const chatUrl = `http://localhost:3000?${params.toString()}`; // Fixed the backticks
      window.open(chatUrl, "chat", "width=1200,height=800");
    },
  },
};
